import { createReducer } from 'typesafe-actions'
import { ModelRecommendationsData } from '../../entities/ModelRecommendationsData'
import { setVwnRecommendationsForModelData, resetVwnRecommendationsForModelData } from '../actions/app/vwnRecommendation.actions'

export type VwnRecommendationsForModelDataState = ModelRecommendationsData

export const defaultState: VwnRecommendationsForModelDataState = {
    recommendations: [],
}

const vwnRecommendationsForModelDataReducer = createReducer(defaultState)
    .handleAction(setVwnRecommendationsForModelData, (state, action) => action.payload)
    .handleAction(resetVwnRecommendationsForModelData, () => defaultState)

export default vwnRecommendationsForModelDataReducer
